<template>
	<div class="full" style="box-sizing: border-box;padding: 10px;">
		<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
		<detail-index :row="currentrow" ref="goodsonlineCost"></detail-index>
		<importTable :ref="importRef" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import detailIndex from './detail/index.vue'
	import importTable from '@_system/components/import/index.vue'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		
		data() {
			return {
				currentrow:null,
				list_formConfig: [{
					field: 'shopUid',
					title: '店铺',
					itemRender: {	
						name: '$select',
						props:{
							emptyoption:false,
							selectoptions:[]
						}

					}
				},{
					field: 'itemId',
					title: '商品ID',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'itemTitle',
					title: '标题',
					itemRender: {
						name: '$input'
					}
				}],
				importRef: Math.random(),
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			this.$refs[this.importRef].importcomfig = this.importcomfig
			this.$refs[this.importRef].moduleImport = this.moduleImport
		},
		methods: {
			importpanel() {
				this.$refs[this.importRef].importpanel()
			},
			importcomfig(){
				let res =[{
					code:'goodsrelation',
					config:'update',
					configtype:'custom',
					name:'线上商品价格',
					columns:[{
						config:['unique'],
						field:'main|realskuId',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_goodsrelation_detail',
						tablename:'商品对应关系明细',
						tabletype:'main',
						title:'SKUID',
					},{
						config:['unique'],
						field:'main|itemCode',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_goodsrelation_detail',
						tablename:'商品对应关系明细',
						tabletype:'main',
						title:'sku编码',
					},{
						config:[],
						field:'main|onlineprice',
						name:'$inputNumber',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_goodsrelation_detail',
						tablename:'商品对应关系明细',
						tabletype:'main',
						title:'线上价格',
					}]
				}]
				return Promise.resolve(res) 
			},
			moduleImport(formData) {
				return new Promise((reslove,reject)=>{
					this.$api.goodsonline.import(formData).then((res)=>{
						reslove(res)						
					},()=>{
						reject()
					})
				})				
			},
			list_init() {
				this.init_formButton()
				let list_gridOptions = this.list_getOption()
				this.list_beforeCreateGrid(list_gridOptions).then(()=>{
					this.list_gridOptions = list_gridOptions
				})
				
			},
			list_beforeCreateGrid(gridOptions){		
				gridOptions.toolbarConfig.buttons = [{
					name: '导入',
					status: 'primary',
					code: 'importpanel'
				},{
					name: '导出',
					status: 'success',
					code: 'export'
				}]
				gridOptions.columns = [{
						field: 'shopname',
						title: '店铺',
					},
					{
						field: 'itemId',
						title: '商品ID'
					},
					{
						field: 'itemTitle',
						title: '标题',
					},
					{
						field: 'itemCode',
						title: '商家编码',
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button type = "text" size = "mini" onClick = {() => {this.detail(row)}}>详情</el-button>]
							}
						}
					}
				]
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500],
				}
				gridOptions.formConfig.span = 4
				
				return new Promise((reslove)=>{
					this.$api.goodsonline.getshop().then((res)=>{
						this.list_formConfig[0].itemRender.props.selectoptions = res.map((item)=>{
							return {value:item.shopUid,label:item.shopName}
						})
						reslove()
					})
				})
				
			},
			detail(row){
				this.currentrow = row
				this.$refs.goodsonlineCost.title = '线上ID：'+ row.itemId
				this.$refs.goodsonlineCost.modalShow = true
				
			},
			list(page,updateForm) {
				return new Promise((resolve) => {
					this.$api.goodsonline.list({
						...page,
						...updateForm
					}).then((data)=>{
						resolve(data)
					})
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			detailIndex,
			importTable,
		}
	}
</script>
